<template>
  <div class="main">
    <Header
      :show="true"
      title="首页"
      left=""
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-cell-group>
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <div
                style="
                  width: 4px;
                  height: 2.2vh;
                  background-color: #ea7e2d;
                  border-radius: 0.6vw;
                  float: left;
                  margin-top: 2px;
                "
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
                >实时数据</span
              >
            </div>
          </template>
          <template #right-icon>
            <img
              src="@/assets/svg/iconLiShiCaoZuoXiangQing.svg"
              height="26px;"
              @click="handleClickDetail"
            />
          </template>
        </van-cell>
      </van-cell-group>
      <van-tabs v-model="active">
        <van-tab>
          <div slot="title">
            <div class="day-statistics">
              <img
                src="@/assets/dashboard/iconOrderTimes.svg"
                height=".4rem;"
              />
              <span style="margin-top: 0.1rem"
                >{{ gateList[0].orderCount }}/{{
                  gateList[0].accessCount
                }}次</span
              >
            </div>
          </div>
          <div style="background-color: #ffffff; padding: 10px">
            <div>
              <van-button type="info" size="small"> 最新状态 </van-button>
              <van-button plain type="default" size="small">
                {{ manNews.content }}
              </van-button>
            </div>
            <div>
              <van-button type="info" size="small"> 办公区访问量 </van-button>
              <van-button plain type="default" size="small">
                预约 {{ gateList[0].orderCount1 }} 次
              </van-button>
              <van-button plain type="default" size="small">
                实际 {{ gateList[0].accessCount1 }} 次
              </van-button>
            </div>
            <div>
              <van-button type="info" size="small"> 生产区访问量 </van-button>
              <van-button plain type="default" size="small">
                预约 {{ gateList[0].orderCount2 }} 次
              </van-button>
              <van-button plain type="default" size="small">
                实际 {{ gateList[0].accessCount2 }} 次
              </van-button>
            </div>
          </div>
        </van-tab>
        <van-tab>
          <div slot="title">
            <div class="day-statistics">
              <img src="@/assets/dashboard/iconTankTruck.svg" height=".4rem;" />
              <span style="margin-top: 0.1rem"
                >{{ gateList[3].orderCount }}/{{
                  gateList[3].accessCount
                }}车</span
              >
            </div>
          </div>
          <div style="background-color: #ffffff; padding: 10px">
            <div>
              <van-button type="info" size="small"> 最新状态 </van-button>
              <van-button plain type="default" size="small">
                {{ tankNews.content }}
              </van-button>
            </div>
            <div>
              <van-button type="info" size="small"> 罐装货车 </van-button>
              <van-button plain type="default" size="small">
                预约 {{ gateList[3].orderCount }} 次
              </van-button>
              <van-button plain type="default" size="small">
                实际 {{ gateList[3].accessCount }} 次
              </van-button>
            </div>
            <div>
              <van-button type="info" size="small"> 装车重量 </van-button>
              <van-button plain type="default" size="small">
                累计 {{ gateList[3].totalWeight }} 吨
              </van-button>
            </div>
          </div>
        </van-tab>
        <van-tab>
          <div slot="title">
            <div class="day-statistics">
              <img
                src="@/assets/dashboard/iconAggregateTruck.svg"
                height=".4rem;"
              />
              <span style="margin-top: 0.1rem"
                >{{ gateList[2].orderCount }}/{{
                  gateList[2].accessCount
                }}车</span
              >
            </div>
          </div>
          <div style="background-color: #ffffff; padding: 10px">
            <div>
              <van-button type="info" size="small"> 最新状态 </van-button>
              <van-button plain type="default" size="small">
                {{ aggregateNews.content }}
              </van-button>
            </div>
            <div>
              <van-button type="info" size="small"> 骨料货车 </van-button>
              <van-button plain type="default" size="small">
                预约 {{ gateList[2].orderCount }} 次
              </van-button>
              <van-button plain type="default" size="small">
                实际 {{ gateList[2].accessCount }} 次
              </van-button>
            </div>
            <div>
              <van-button type="info" size="small"> 装车重量 </van-button>
              <van-button plain type="default" size="small">
                累计 {{ gateList[2].totalWeight }} 吨
              </van-button>
            </div>
          </div>
        </van-tab>
        <van-tab>
          <div slot="title">
            <div class="day-statistics">
              <img
                src="@/assets/dashboard/iconConcreteTruck.svg"
                height=".4rem;"
              />
              <span style="margin-top: 0.1rem"
                >{{ gateList[1].orderCount }}/{{
                  gateList[1].accessCount
                }}车</span
              >
            </div>
          </div>
          <div style="background-color: #ffffff; padding: 10px">
            <div>
              <van-button type="info" size="small"> 最新状态 </van-button>
              <van-button plain type="default" size="small">
                {{ concreteNews.content }}
              </van-button>
            </div>
            <div>
              <van-button type="info" size="small"> 商砼货车 </van-button>
              <van-button plain type="default" size="small">
                预约 {{ gateList[1].orderCount }} 次
              </van-button>
              <van-button plain type="default" size="small">
                实际 {{ gateList[1].accessCount }} 次
              </van-button>
            </div>
            <div>
              <van-button type="info" size="small"> 装车重量 </van-button>
              <van-button plain type="default" size="small">
                累计 {{ gateList[1].totalWeight }} 吨
              </van-button>
            </div>
          </div>
        </van-tab>
      </van-tabs>

      <div style="height: 8px; background-color: #f8f8f8" />
      <van-cell-group>
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <div
                style="
                  width: 4px;
                  height: 2.2vh;
                  background-color: #ea7e2d;
                  border-radius: 0.6vw;
                  float: left;
                  margin-top: 2px;
                "
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
                >罐口状态</span
              >
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-row
        v-for="activity in portList"
        :key="activity.id"
        style="display: flex; align-items: center"
      >
        <van-col span="4" offset="1">
          <van-image
            width="64px"
            height="64px"
            fit="contain"
            :src="
              activity.status === 0
                ? imageSrc.iconDeviceEnable
                : imageSrc.iconDeviceClose
            "
            style="padding: 7px 0"
          />
        </van-col>
        <van-col span="18" offset="1">
          <div>
            <van-row style="color: #464646">
              <van-col span="18">
                {{ activity.name }}
              </van-col>
            </van-row>
            <van-row style="color: #c0c0c0">
              <van-col span="18">
                {{ activity.material }}
              </van-col>
            </van-row>
            <van-row>
              <van-col span="18" class="gk-text">
                {{ activity.value }}
              </van-col>
              <van-col
                offset="2"
                :style="{ color: deviceStatus[activity.status].color }"
              >
                {{ deviceStatus[activity.status].word }}
              </van-col>
            </van-row>
          </div>
        </van-col>
      </van-row>
    </div>
    <Footer value="dashboard" />
  </div>
</template>

<script>
import { Dialog } from "vant";
import { parseTime } from "@/utils";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { showPhoneAlarm } from "@/global/function.js";
import { visitor } from "@/views/dashboard/config.json";
import {
  getGateList,
  getEquipmentList,
  getManOrderList,
  getManAccessList,
  getTruckOrderList,
  getTruckAccessList,
  getWeighBridgeList,
  getMaterialCheckList,
} from "@/api/dashboard.js";
import { getList as getMaterialPortList } from "@/api/material-port.js";

export default {
  name: "Dashboard",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    const EDate = parseTime(new Date(), "{y}/{m}/{d}");
    const dayTimeStamp = new Date(EDate).getTime();
    const beforeTimeStamp = dayTimeStamp - 1 * 24 * 3600 * 1000;
    const SDate = parseTime(beforeTimeStamp, "{y}/{m}/{d}");
    return {
      deviceStatus: [
        {
          color: "#67C23A",
          word: "开启",
        },
        {
          color: "#E6A23C",
          word: "告警",
        },
        {
          color: "#F56C6C",
          word: "故障",
        },
        {
          color: "#909399",
          word: "关闭",
        },
      ],
      imageSrc: {
        iconSheBeiXieLiaoGuanKou: require("@/assets/svg/iconSheBeiXieLiaoGuanKou.svg"),
        iconDeviceEnable: require("@/assets/svg/iconDeviceEnable.svg"),
        iconDeviceClose: require("@/assets/svg/iconDeviceClose.svg"),
      },
      portList: [],
      active: 0,
      gateList: [
        {
          orderCount: 0,
          accessCount: 0,
          orderCount1: 0,
          accessCount1: 0,
          orderCount2: 0,
          accessCount2: 0,
          totalWeight: 0,
        },
        {
          orderCount: 0,
          accessCount: 0,
          totalWeight: 0,
        },
        {
          orderCount: 0,
          accessCount: 0,
          totalWeight: 0,
        },
        {
          orderCount: 0,
          accessCount: 0,
          totalWeight: 0,
        },
      ],
      intervalId: null,
      listQuery: {
        limit: 100,
        page: 1,
        start: beforeTimeStamp,
        end: dayTimeStamp,
      },
      telphone: "0797-8181868",
      isLoading: false,
      manOrderList: [],
      manAccessList: [],
      truckOrderList: [],
      truckAccessList: [],
      weighList: [],
      checkList: [],
      guide: "欢迎您光临永固万年青新型建材有限公司！",
      manNews: {
        timestamp: 0,
        content: "无记录",
      },
      aggregateNews: {
        timestamp: 0,
        content: "无记录",
      },
      tankNews: {
        timestamp: 0,
        content: "无记录",
      },
      concreteNews: {
        timestamp: 0,
        content: "无记录",
      },
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {
    this.handleGetGateList();
    this.handleGetEquipmentList();
    this.handleGetMaterialPortList();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      // this.$router.go(-1)
      console.log("dashboard-left");
    },
    handleClickRight() {
      console.log("dashboard-right");
    },
    handleCallForHelp() {
      // window.location.href = 'tel: ' + this.telphone
      Dialog.alert({
        title: "获取帮助",
        message: "如果您遇到什么问题，请联系：\n0797-8181868",
      }).then(() => {});
    },
    handleClickDetail() {
      this.$router.push({ path: "/dashboard/time-line", query: {} });
    },
    handleGetEquipmentList() {
      const data = {};
      getEquipmentList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data;
            for (let i = 0; i < items.length; i++) {
              switch (items[i].type) {
                case 1:
                  this.gateList[0].orderCount1 = items[i].orderCount;
                  this.gateList[0].accessCount1 = items[i].accessCount;
                  break;
                case 2:
                  this.gateList[0].orderCount2 = items[i].orderCount;
                  this.gateList[0].accessCount2 = items[i].accessCount;
                  break;
                default:
                  break;
              }
            }
            this.gateList[0].orderCount =
              this.gateList[0].orderCount1 + this.gateList[0].orderCount2;
            this.gateList[0].accessCount =
              this.gateList[0].accessCount1 + this.gateList[0].accessCount2;
            this.gateList.push({
              orderCount: 0,
              accessCount: 0,
              totalWeight: 0,
            });
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetGateList() {
      const data = {};
      getGateList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data;
            for (let i = 0; i < items.length; i++) {
              let totalWeight = 0;
              switch (items[i].type) {
                case 2:
                  this.gateList[1].orderCount = items[i].orderCount;
                  this.gateList[1].accessCount = items[i].accessCount;
                  totalWeight = 0;
                  for (let j = 0; j < items[i].truckLoadList.length; j++) {
                    totalWeight += items[i].truckLoadList[j].weight;
                  }
                  this.gateList[1].totalWeight = parseFloat(
                    totalWeight
                  ).toFixed(2);
                  break;
                case 3:
                  this.gateList[2].orderCount = items[i].orderCount;
                  this.gateList[2].accessCount = items[i].accessCount;
                  totalWeight = 0;
                  for (let j = 0; j < items[i].truckLoadList.length; j++) {
                    totalWeight += items[i].truckLoadList[j].weight;
                  }
                  this.gateList[2].totalWeight = parseFloat(
                    totalWeight
                  ).toFixed(2);
                  break;
                case 4:
                  this.gateList[3].orderCount = items[i].orderCount;
                  this.gateList[3].accessCount = items[i].accessCount;
                  totalWeight = 0;
                  for (let j = 0; j < items[i].truckLoadList.length; j++) {
                    totalWeight += items[i].truckLoadList[j].weight;
                  }
                  this.gateList[3].totalWeight = parseFloat(
                    totalWeight
                  ).toFixed(2);
                  break;
                default:
                  break;
              }
            }
            this.gateList.push({
              orderCount: 0,
              accessCount: 0,
              totalWeight: 0,
            });
            // bus.$emit('MonitorMotionGateData', this.gateList)
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetMaterialPortList() {
      const data = {};
      getMaterialPortList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data;
            this.portList = [];
            for (let i = 0; i < items.length; i++) {
              if (items[i].type !== 2) continue;
              this.portList.push({
                id: i,
                name: items[i].portName,
                material: items[i].materialName,
                value:
                  items[i].jarStock +
                  "吨 / " +
                  items[i].capacity +
                  "吨 / " +
                  items[i].totalCapacity +
                  "吨 / " +
                  items[i].lowerCapacity +
                  "吨",
                status: items[i].using === true ? 0 : 3,
              });
            }
            console.log(this.portList);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
.van-cell {
  padding: 1.5vw 3vw;
}
::v-deep .van-col {
  line-height: 22px;
}
::v-deep .van-cell__label {
  width: 60vw;
}
::v-deep .van-grid-item__content {
  padding: 0.6rem 0;
}
::v-deep .van-tabs--line .van-tabs__wrap {
  height: 80px;
}
.van-button--primary {
  margin: 5px 5px 5px 5px;
}
.van-button--info {
  margin: 5px 5px 5px 5px;
}
.van-button--warning {
  margin: 5px 5px 5px 5px;
}
.van-button--default {
  margin: 5px 5px 5px 5px;
}
.van-divider {
  margin: 0;
  background-color: #ffffff;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
.day-statistics {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
}
.gk-text {
  white-space: nowrap;
}
</style>
